import type { NetWorthHistoryPoint } from '../types/api';

const n = (s: string | undefined) => {
  const v = parseFloat(s ?? '0');
  return Number.isFinite(v) ? v : 0;
};

/**
 * Drops the months before a household's history really starts, so the trend
 * chart does not open on a flat ~$0 run and then leap (issue #27 follow-up).
 * Mirrors services.TrimLeadingNetWorth on the backend, which trims the
 * dashboard sparkline the same way.
 *
 *  1. months with nothing at all (no assets, investments or debts);
 *  2. when net worth is ever positive, the months before it first is -- a
 *     household that is negative throughout keeps them;
 *  3. a first month under a tenth of the next: the month opening balances
 *     were only partly posted. Real growth does not multiply tenfold in a month.
 *
 * Always keeps at least two points so a line can be drawn.
 */
export function trimLeadingNetWorth(points: NetWorthHistoryPoint[]): NetWorthHistoryPoint[] {
  let out = points;
  while (
    out.length > 0 &&
    n(out[0].total_assets) === 0 && n(out[0].total_investments) === 0 && n(out[0].total_debts) === 0
  ) {
    out = out.slice(1);
  }
  if (out.some((p) => n(p.net_worth) > 0)) {
    while (out.length > 0 && n(out[0].net_worth) <= 0) out = out.slice(1);
  }
  while (out.length > 1 && n(out[1].net_worth) > 0 && n(out[0].net_worth) < n(out[1].net_worth) * 0.1) {
    out = out.slice(1);
  }
  if (out.length < 2 && points.length >= 2) return points.slice(-2);
  return out;
}
